var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTruckLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.56877 15.7375C3.64064 16.0031 3.91564 16.1625 4.18127 16.0906L10.9438 14.2781C11.2094 14.2062 11.3688 13.9312 11.2969 13.6656L9.74376 7.86875C9.67189 7.60312 9.39689 7.44375 9.13126 7.51562L6.71876 8.16562L7.49376 11.0625L5.56251 11.5781L4.78751 8.68125L2.37189 9.32812C2.10627 9.4 1.94689 9.675 2.01877 9.94062L3.56877 15.7375ZM14 4C13.4469 4 13 4.44687 13 5V15.1125L2.18439 18.0625C2.05002 18.1 1.97189 18.2375 2.00939 18.3687L2.40314 19.8156C2.44064 19.95 2.57814 20.0281 2.70939 19.9906L15.0125 16.6344C15.0875 18.5031 16.6125 20 18.5 20C20.4344 20 22 18.4344 22 16.5V4H14ZM18.5 18C17.6719 18 17 17.3281 17 16.5C17 15.6719 17.6719 15 18.5 15C19.3281 15 20 15.6719 20 16.5C20 17.3281 19.3281 18 18.5 18Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTruckLoading);
export default __webpack_public_path__ + "static/media/truck-loading.edb8319477bfd07862021d1fb076c02b.svg";
export { ForwardRef as ReactComponent };